<template>
  <display-control
    :data-aid="actor.id"
    :component="actor.component"
    :name="(currentSnapshot.rev === 2 ? actor.title : actor.name)"
    :description="actor.description"
    :status-var="getStatusVarByControlActor(actor)"
    :vars="getActorVars(actor)"
    :show-label="showLabel"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DisplayControl from "@/components/services/service/DisplayControl";

export default {
  name: 'ControlActor',
  components: { DisplayControl },
  props: {
    actor: {
      required: true,
      type: Object,
    },
    showLabel: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      componentsWithLabels: [
        'SliderSwitch',
      ],
      inlineComponents: [
        'SliderSwitch',
      ],
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getActorVars',
      'getStatusVarByControlActor',
    ]),
  },
};
</script>

<style scoped>

</style>
